// extracted by mini-css-extract-plugin
export const sectionReviewsWidget = "reviewsWidget-module--sectionReviewsWidget--r3m61";
export const sectionContent = "reviewsWidget-module--sectionContent--3HFV7";
export const listingWrap = "reviewsWidget-module--listingWrap--2zTDF";
export const listingItem = "reviewsWidget-module--listingItem--3w56g";
export const itemHead = "reviewsWidget-module--itemHead--36SjE";
export const itemRatingWrap = "reviewsWidget-module--itemRatingWrap--1UeGa";
export const itemImage = "reviewsWidget-module--itemImage--2SiKD";
export const itemImageBackground = "reviewsWidget-module--itemImageBackground--W2YDx";
export const itemRating = "reviewsWidget-module--itemRating--3pqkZ";
export const itemDetails = "reviewsWidget-module--itemDetails--1JsM-";
export const iconsBar = "reviewsWidget-module--iconsBar--aT4D6";
export const itemCta = "reviewsWidget-module--itemCta--359yc";